import React, { useState } from 'react'

import { Tabs } from 'antd';
import TabpanelDetail from '../Table/TabpanelDetail'
import DetailPageInfo from './DetailPageInfo';
import PageContainer from '../../CSIComponents/PageContainer';

const { TabPane } = Tabs;
interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,

}
const AmentiesIndex = (props: propsTypes) => {
    const [addFlag, setAddFlag] = useState(false);
    const [editFlag, setEditFlag] = useState(false);
    const [tableCurrentData, setTableCurrentData] = useState([]);
    const addHandle = () => {
        setAddFlag(true)
        setEditFlag(false)
    }
    const editHandle = (record?: any) => {
        setAddFlag(false)
        setEditFlag(true)
        record ? setTableCurrentData(record) : setTableCurrentData([]);
    }
    const cancelAndSave = () => {
        setAddFlag(false)
        setEditFlag(false)
    }

    return (
        <>
            <div className="amenitiesItem">
                {!addFlag && !editFlag && <Tabs defaultActiveKey="1">
                    <TabPane tab="Amenities & Services Table" key="1">
                        <PageContainer><TabpanelDetail addAndEdit={addHandle} detailAndedit={editHandle} /></PageContainer>
                    </TabPane>
                </Tabs>}
                {addFlag && <DetailPageInfo cancelAndSave={cancelAndSave} isEditable={props.isEditable} cancelEditable={props.cancelEditable} />}
                {editFlag && <DetailPageInfo cancelAndSave={cancelAndSave} tableCurrentData={tableCurrentData} detail='true' isEditable={props.isEditable} cancelEditable={props.cancelEditable} />}
            </div>
        </>
    )
}

export default AmentiesIndex;

